import { createRoot } from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Remove the server-rendered SEO tags before the first render. React 19 would otherwise adopt
// matching <title>/<meta>/<link> nodes from <head> instead of creating its own.
document.head
	.querySelectorAll('title, meta[name="description"], link[rel="canonical"], link[rel="alternate"][hreflang]:not([hreflang="x-default"])')
	.forEach((node) => node.remove());

const root = document.getElementById('root');
if (root) createRoot(root).render(<App />);

// If you want to start measuring performance in your app, pass a <function></function>
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
